<template>
  <div>
    <Dashboard ref="Dashboard" class="dashboard" :score="score" />
    <div class="card">
      <div class="title">我的數據<span>近30日</span></div>
      <ul>
        <li
          v-for="(item, index) in list"
          :key="index"
          :style="{ zIndex: item.showIntro ? 1 : 0 }"
        >
          <div class="type">
            {{ item.type }}
            <div class="attention" @click.stop="showIntro(index)" @mouseover.stop="showIntro(index)" @mouseleave.stop="closeIntro">
              <fps-icon class="attention-icon" type="warning-inline" size="18" />
              <div v-show="item.showIntro" class="triangle"></div>
            </div>
          </div>
          <div class="data" v-if="diffInfo">
            {{ scoreDetail[item.key]
            }}<span
              class="diff-tag"
              v-if="diffInfo[item.diff] > 0"
              :style="{ color: item.color }"
              >+{{ diffInfo[item.diff] }}</span
            >
          </div>
          <div v-show="item.showIntro" class="intro" @click.stop>
            <p>{{ item.intro }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Dashboard from './dashboard.vue'

export default {
  components: {
    Dashboard
  },
  data() {
    const list = [
      {
        type: '下單新用戶數',
        intro: '在平台首次下單新用戶人數',
        key: 'newOrderUser',
        diff: 'orderUserDiff',
        showIntro: false,
        color: '#5AB64E'
      },
      {
        type: '二次下單人數',
        intro: '對你下單並完成付款超過一次的人數',
        key: 'secondOrderUser',
        diff: 'secondOrderUserDiff',
        showIntro: false,
        color: '#FA6579'
      },
      {
        type: '有效好評數',
        intro: '五個字以上的五星好評的個數',
        key: 'positiveComment',
        diff: 'positiveCommentDiff',
        showIntro: false,
        color: '#FA6579'
      },
      {
        type: '二次下單訂單金額',
        intro: '對你下單並完成付款超過一次的人產生的訂單金額',
        key: 'secondOrderAmount',
        diff: 'secondOrderAmountDiff',
        showIntro: false,
        color: '#FA6579'
      },
    ];
    return {
      list,
      timer: null,
      diffInfo: {},
      scoreDetail: {}
    };
  },
  props: {
    score: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getData() {
      return this.$http.get('/master/score/detail').then(({ data }) => {
        if(!data) return;
        this.scoreDetail = data;
        this.scoreDetail.secondOrderAmount =
          '$' + this.$util.moneySplit(this.scoreDetail.secondOrderAmount);
      });
    },
    /**
     * @description: 获取对比信息
     */
    getDiffInfo() {
      return this.$http.get('/player/score/query/diff').then(({ data }) => {
        this.diffInfo = data;
      });
    },
    closeIntro() {
      this.list.forEach(item => {
        item.showIntro = false;
      });
    },
    showIntro(index) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.closeIntro();
      this.$nextTick(() => {
        this.list[index].showIntro = true;
      });
      this.timer = setTimeout(() => {
        this.list[index].showIntro = false;
      }, 5000);
    },
    /**
     * @description: 触发动画
     */
    animate() {
      this.$refs.Dashboard.animate()
    },
  },
  created() {
    Promise.all([this.getDiffInfo(), this.getData()])
  },
  mounted() {
    window.addEventListener('click', this.closeIntro);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.closeIntro);
  }
};
</script>
<style lang="scss" scoped>
.dashboard {
  height: 212px;
}
.card {
  @include flex(flex-start, stretch, column);
  position: relative;
  width: 100%;
  height: 189px;
  background: #fff;
  margin: 0 auto;
  border-radius: 10px;
  padding: 20px 24px;
  text-align: left;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  
  .title {
    color: #333;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    span {
      color: #999;
      font-size: 12px;
      font-weight: normal;
      margin-left: 8px;
    }
  }
  ul {
    flex-grow: 1;
    position: relative;
    li {
      position: relative;
      float: left;
      width: 50%;
      height: 50%;
      padding-top: 10px;
      .type {
        @include flex(flex-start);
        position: relative;
        color: #999;
        font-size: 12px;
        .attention {
          position: relative;
          width: 24px;
          height: 24px;
          @include flex;
          .attention-icon {
            color: #999;
            transform: scaleY(-1);
          }
          .triangle {
            position: absolute;
            left: 12px;
            top: 28px;
            transform: translate(-50%, -100%);
            @include triangle(9px, rgba(62, 69, 87, 0.95), top);
          }
        }
      }
      .data {
        display: flex;
        align-self: center;
        color: #333;
        font-size: 18px;
        font-weight: 500;
        line-height: 25px;
      }
      .intro {
        position: absolute;
        left: 0;
        top: 38px;
        width: 200%;
        p {
          float: left;
          padding: 10px 15px;
          color: #fff;
          font-size: 14px;
          line-height: 20px;
          background: rgba(62, 69, 87, 0.95);
          box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.08);
          backdrop-filter: blur(13px);
          border-radius: 4px;
        }
      }
      &:nth-child(even) {
        padding-left: 18px;
        .intro {
          left: auto;
          right: 0;
          p {
            float: right;
          }
        }
      }
    }
  }
}
.diff-tag {
  margin-left: 5px;
  font-size: 12px;
}
</style>
